import RoutePublic from './RoutePublic';

export default RoutePublic;
